import { CellContext, ColumnHelper, createColumnHelper } from "@tanstack/react-table";
import { IActoCondicionSubestandar } from "../../entities/IActoCondicionSubestandar";
import { IAgentesCausantes } from "../../entities/IAgentesCausantes";
import { IAmbitoDesviacion } from "../../entities/IAmbitoDesviacion";
import { IAreaResponsable } from "../../entities/IAreaResponsable";
import { ICapacidades } from "../../entities/ICapacidades";
import ContratistasResponsable from "../../entities/IContratistasResponsable";
import IContrato from "../../entities/IContrato";
import { IEfectos } from "../../entities/IEfectos";
import { IFactoresPersonales } from "../../entities/IFactoresPersonales";
import IGerencia from "../../entities/IGerencia";
import { IGravedadPotencial } from "../../entities/IGravedadPotencial";
import { INaturalezaLesiones } from "../../entities/INaturalezaLesiones";
import { INotificacion } from "../../entities/INotificacion";
import { IParteCuerpoLesionado } from "../../entities/IParteCuerpoLesionado";
import { IRequisitoSistema } from "../../entities/IRequisitoSistema";
import ISubContratista from "../../entities/ISubContratista";
import { ITipoCausaBasica } from "../../entities/ITipoCausaBasica";
import { ITipoContacto } from "../../entities/ITipoContacto";
import { ITipoDesviacion } from "../../entities/ITipoDesviacion";
import { ITipoProceso } from "../../entities/ITipoProceso";
import IUnidad from "../../entities/IUnidad";
import IVicePresidencia from "../../entities/IVicePresidencia";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import ITipoIncidentes from "../../entities/ITipoIncidentes";
import ITipoIncidenteUsuario from "../../entities/ITipoIncidenteUsuario";
import IAspecto from "../../entities/IAspecto";
import { ITipoAuditoria } from "../../entities/ITipoAuditoria";
import { ITipoUnidadAuditar } from "../../entities/ITipoUnidadAuditar";
import { ITipoAlcance } from "../../entities/ITipoAlcance";
import ITipoFaena from "../../entities/ITipoFaena";
import IFaena from "../../entities/IFaena";
import ITipoEvaluacion from "../../entities/ITipoEvaluacion";
import ILIOInspectorTranselec from "../../entities/ILIOInspectorTranselec";
import { IRoles } from "../../entities/IRoles";
import { useMenuTrigger_unstable } from "@fluentui/react-components";

export interface IForm {
  tipo: ITipo_Campo;
  texto: string;
  id: string;
  title: string;
  hide: boolean;
  readonly?: boolean;
  hideColOnEdit: boolean;
  options?: Array<any>;
  callback?: (id: string, value: any) => void;
  required: boolean;
  errorEmpty: boolean;
}

export function AdminListColumn(tipoConsulta: string | null): Array<any> {
  // NOSONAR Dejamos justificado que necesitamos un switch con mas de 30 opciones ya que este método permite generar las columas de las listas mantenedoras, y el sistema el SGITOOLS tiene mas de 30 listas mantenedoras
  switch (
    tipoConsulta // NOSONAR Dejamos justificado que necesitamos un switch con mas de 30 opciones ya que este método permite generar las columas de las listas mantenedoras, y el sistema el SGITOOLS tiene mas de 30 listas mantenedoras
  ) {
    case "Vicepresidencia":
      const columnHelperVP = createColumnHelper<IVicePresidencia>();
      const cols = [
        columnHelperVP.accessor("ID", {
          cell: (info: CellContext<IVicePresidencia, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.none,
          title: "ID",
        } as any),
        columnHelperVP.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IVicePresidencia, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperVP.accessor((row) => row.USUARIO_RESPONSABLE, {
          id: "USUARIO_RESPONSABLE",
          cell: (info: CellContext<IVicePresidencia, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Usuario responsable",
          hide: true,
          required: true,
        } as any),
        columnHelperVP.accessor((row) => row.USUARIO_RESPONSABLE_DISPLAY, {
          id: "USUARIO_RESPONSABLE_DISPLAY",
          cell: (info: CellContext<IVicePresidencia, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.none,
        } as any),
        columnHelperVP.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IVicePresidencia, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperVP.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<IVicePresidencia, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return cols as any;
    case "Gerencia":
      const columnHelperG: ColumnHelper<IGerencia> = createColumnHelper<IGerencia>();
      return [
        columnHelperG.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGerencia, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperG.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGerencia, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperG.accessor((row) => row.NOMBRE_VICEPRESIDENCIA, {
          id: "ID_VICEPRESIDENCIA",
          cell: (info: CellContext<IGerencia, number>) => <i>{info.getValue()}</i>,
          header: () => <span>VicePresidencia</span>,
          tipo: ITipo_Campo.combo,
          title: "VicePresidencia",
          required: true,
        } as any),
        columnHelperG.accessor((row) => row.USUARIO_RESPONSABLE_DISPLAY, {
          id: "USUARIO_RESPONSABLE",
          cell: (info: CellContext<IGerencia, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Usuario responsable",
          required: true,
        } as any),
        columnHelperG.accessor((row) => row.USUARIO_BACKUP_DISPLAY, {
          id: "USUARIO_BACKUP",
          cell: (info: CellContext<IGerencia, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario backup</span>,
          tipo: ITipo_Campo.user,
          title: "Usuario backup",
          required: useMenuTrigger_unstable,
        } as any),
        columnHelperG.accessor((row) => row.ES_USUARIO_BACKUP, {
          id: "ES_USUARIO_BACKUP",
          cell: (info: CellContext<IGerencia, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>¿Es Usuario backup?</span>,
          tipo: ITipo_Campo.check,
          title: "¿Es Usuario backup?",
        } as any),
        columnHelperG.accessor((row) => row.GERENTE_RESPONSABLE_DISPLAY, {
          id: "GERENTE_RESPONSABLE",
          cell: (info: CellContext<IGerencia, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Gerente responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Gerente responsable",
          required: true,
        } as any),
        columnHelperG.accessor((row) => row.GERENTE_BACKUP_DISPLAY, {
          id: "GERENTE_BACKUP",
          cell: (info: CellContext<IGerencia, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Gerente responsable backup</span>,
          tipo: ITipo_Campo.user,
          title: "Backup gerente",
          required: true,
        } as any),
        columnHelperG.accessor((row) => row.ES_GERENTE_BACKUP, {
          id: "ES_GERENTE_BACKUP",
          cell: (info: CellContext<IGerencia, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>¿Es gerente backup?</span>,
          tipo: ITipo_Campo.check,
          title: "¿Es gerente backup?",
        } as any),
        columnHelperG.accessor((row) => row.ENCARGADO_ZONAL_DISPLAY, {
          id: "ENCARGADO_ZONAL",
          cell: (info: CellContext<IGerencia, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Encargado zonal</span>,
          tipo: ITipo_Campo.multiuser,
          title: "Encargado zonal",
          required: true,
        } as any),
        columnHelperG.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGerencia, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperG.accessor((row) => row.ID_MAESTRO_GERENCIA_SUBGERENCIA, {
          id: "ID_MAESTRO_GERENCIA_SUBGERENCIA",
          cell: (info: CellContext<IGerencia, number>) => <i>{info.getValue()}</i>,
          // header: () => <span>Activo</span>,
          tipo: ITipo_Campo.key,
          hide: true,
          title: "Activo",
        } as any),
        columnHelperG.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "Unidad":
      const columnHelperUnidad = createColumnHelper<IUnidad>();

      return [
        columnHelperUnidad.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IUnidad, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperUnidad.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IUnidad, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
          sorteditmode: 1,
        } as any),
        columnHelperUnidad.accessor((row) => row.NOMBRE_GERENCIA_SUBGERENCIA, {
          id: "ID_GERENCIA_SUBGERENCIA",
          cell: (info: CellContext<IUnidad, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Gerencia</span>,
          tipo: ITipo_Campo.combo,
          title: "Gerencia",
          hide: true,
          required: true,
          sorteditmode: 2,
        } as any),
        columnHelperUnidad.accessor((row) => row.NOMBRE_GERENCIA_SUBGERENCIA, {
          id: "NOMBRE_GERENCIA_SUBGERENCIA",
          cell: (info: CellContext<IUnidad, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Gerencia</span>,
          tipo: ITipo_Campo.none,
        } as any),
        columnHelperUnidad.accessor((row) => row.NOMBRE_PROYECTO, {
          id: "NOMBRE_PROYECTO",
          cell: (info: CellContext<IUnidad, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Proyecto</span>,
          tipo: ITipo_Campo.text,
          title: "Proyecto",
          required: true,
          sorteditmode: 3,
        } as any),
        columnHelperUnidad.accessor((row) => row.USUARIO_RESPONSABLE_DISPLAY, {
          id: "USUARIO_RESPONSABLE",
          cell: (info: CellContext<IUnidad, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Responsable",
          required: true,
          sorteditmode: 4,
        } as any),
        columnHelperUnidad.accessor((row) => row.ES_USUARIO_BACKUP, {
          id: "ES_USUARIO_BACKUP",
          cell: (info: CellContext<IUnidad, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>¿Es Usuario backup?</span>,
          tipo: ITipo_Campo.check,
          title: "¿Es Usuario backup?",
          sorteditmode: 6,
        } as any),
        columnHelperUnidad.accessor((row) => row.USUARIO_BACKUP_DISPLAY, {
          id: "USUARIO_BACKUP",
          cell: (info: CellContext<IUnidad, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario backup</span>,
          tipo: ITipo_Campo.user,
          title: "Responsable backup",
          required: true,
          sorteditmode: 5,
        } as any),
        columnHelperUnidad.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IUnidad, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
          sorteditmode: 7,
        } as any),
        columnHelperUnidad.accessor((row) => row.CORRELATIVO_ACTUAL, {
          id: "CORRELATIVO_ACTUAL",
          cell: (info: CellContext<IGerencia, number>) => <i>{info.getValue()}</i>,
          // header: () => <span>Activo</span>,
          tipo: ITipo_Campo.key,
          hide: true,
          title: "Activo",
        } as any),
        columnHelperUnidad.accessor((row) => row.CORRELATIVO_SIGUIENTE, {
          id: "CORRELATIVO_SIGUIENTE",
          // header: () => <span>Activo</span>,
          tipo: ITipo_Campo.key,
          hide: true,
        } as any),
        columnHelperUnidad.accessor((row) => row.CORRELATIVO_RECLAMOS, {
          id: "CORRELATIVO_RECLAMOS",
          // header: () => <span>Activo</span>,
          tipo: ITipo_Campo.key,
          hide: true,
        } as any),
        columnHelperUnidad.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "Contrato":
      const columnHelperContrato = createColumnHelper<IContrato>();

      let cols2 = [
        columnHelperContrato.accessor("ID", {
          cell: (info) => info.getValue(),
          footer: (info) => info.column.id,
        }),
        columnHelperContrato.accessor((row) => row.TITULO, {
          id: "TITULO",
          tipo: ITipo_Campo.text,
          cell: (info: CellContext<IContrato, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          title: "Título",
          required: true,
        } as any),
        columnHelperContrato.accessor((row) => row.ID_CONTRATISTA_SUBCONTRATISTA, {
          id: "ID_CONTRATISTA_SUBCONTRATISTA",
          cell: (info: CellContext<IContrato, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Contratista</span>,
          tipo: ITipo_Campo.combo,
          title: "Contratista",
          required: true,
          hide: true,
        } as any),
        columnHelperContrato.accessor((row) => row.CONTRATISTA_SUBCONTRATISTA, {
          id: "CONTRATISTA_SUBCONTRATISTA",
          cell: (info: CellContext<IContrato, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Contratista</span>,
          tipo: ITipo_Campo.none,
          title: "Contratista",
        } as any),
        columnHelperContrato.accessor((row) => row.CORRELATIVO_PROVEEDOR, {
          id: "CORRELATIVO_PROVEEDOR",
          tipo: ITipo_Campo.text,
          cell: (info: CellContext<IContrato, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Correlativo proveedor</span>,
          hideColOnEdit: true,
          title: "Correlativo proveedor",
          //required: true
        } as any),
        columnHelperContrato.accessor((row) => row.CODIGO_CONTRATO, {
          id: "CODIGO_CONTRATO",
          cell: (info: CellContext<IContrato, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Código contrato</span>,
          tipo: ITipo_Campo.text,
          title: "Código contrato",
          required: true,
        } as any),
        columnHelperContrato.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IContrato, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperContrato.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ];
      return cols2 as any;
    case "ContratistaSubContratista":
      const columnHelperSubContratista = createColumnHelper<ISubContratista>();

      return [
        columnHelperSubContratista.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ISubContratista, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperSubContratista.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: any) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          title: "Título",
          tipo: ITipo_Campo.text,
          required: true,
        } as any),
        columnHelperSubContratista.accessor((row) => row.ID_MAESTRO, {
          id: "ID_MAESTRO",
          cell: (info: any) => <i>{info.getValue()}</i>,
          title: "Maestro",
          tipo: ITipo_Campo.text,
          header: () => <span>Maestro</span>,
          required: true,
        } as any),

        columnHelperSubContratista.accessor((row) => row.USUARIO_RESPONSABLE, {
          id: "USUARIO_RESPONSABLE",
          cell: (info: CellContext<ISubContratista, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Usuario responsable",
          hide: true,
        } as any),
        columnHelperSubContratista.accessor((row) => row.USUARIO_RESPONSABLE_DISPLAY, {
          id: "USUARIO_RESPONSABLE_DISPLAY",
          cell: (info: CellContext<ISubContratista, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.none,
        } as any),
        columnHelperSubContratista.accessor((row) => row.USUARIO_BACKUP, {
          id: "USUARIO_BACKUP",
          cell: (info: any) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario backup</span>,
          hide: true,
          tipo: ITipo_Campo.user,
          title: "Usuario backup",
        } as any),
        columnHelperSubContratista.accessor((row) => row.USUARIO_BACKUP_DISPLAY, {
          id: "USUARIO_BACKUP_DISPLAY",
          cell: (info: any) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario backup</span>,
          tipo: ITipo_Campo.none,
        } as any),
        columnHelperSubContratista.accessor((row) => row.ES_USUARIO_BACKUP, {
          id: "ES_USUARIO_BACKUP",
          cell: (info: CellContext<ISubContratista, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>, //
          header: () => <span>¿Es Usuario backup?</span>,
          tipo: ITipo_Campo.check,
          title: "¿Es usuario backup?",
        } as any),
        columnHelperSubContratista.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ISubContratista, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>, //
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperSubContratista.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "ContratistasResponsables":
      const columnHelperContratistasResponsables = createColumnHelper<ContratistasResponsable>();

      return [
        columnHelperContratistasResponsables.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ContratistasResponsable, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperContratistasResponsables.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ContratistasResponsable, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperContratistasResponsables.accessor((row) => row.CONTRATISTA, {
          id: "ID_CONTRATISTA_SUBCONTRATISTA",
          cell: (info: CellContext<ContratistasResponsable, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Contratista</span>,
          tipo: ITipo_Campo.combo,
          title: "Contratista",
          required: true,
        } as any),
        columnHelperContratistasResponsables.accessor((row) => row.GERENCIA, {
          id: "ID_GERENCIA_SUBGERENCIA",
          cell: (info: CellContext<ContratistasResponsable, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Gerencia</span>,
          tipo: ITipo_Campo.combo,
          title: "Gerencia",
          required: true,
        } as any),
        columnHelperContratistasResponsables.accessor((row) => row.RESPONSABLE_DISPLAY, {
          id: "RESPONSABLE",
          cell: (info: CellContext<ContratistasResponsable, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Responsable",
          required: true,
        } as any),
        columnHelperContratistasResponsables.accessor((row) => row.PREVENCIONISTA_DISPLAY, {
          id: "PREVENCIONISTA",
          cell: (info: CellContext<ContratistasResponsable, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Prevencionista</span>,
          tipo: ITipo_Campo.user,
          title: "Prevencionista",
          required: true,
        } as any),
        columnHelperContratistasResponsables.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ContratistasResponsable, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperContratistasResponsables.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "Notificaciones":
      const columnHelperNotificacion = createColumnHelper<INotificacion>();

      return [
        columnHelperNotificacion.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<INotificacion, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperNotificacion.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<INotificacion, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperNotificacion.accessor((row) => row.ASUNTO, {
          id: "ASUNTO",
          cell: (info: CellContext<INotificacion, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Asunto</span>,
          tipo: ITipo_Campo.text,
          title: "Asunto",
          hide: true,
          required: true,
        } as any),
        columnHelperNotificacion.accessor((row) => row.CUERPO, {
          id: "CUERPO",
          cell: (info: CellContext<INotificacion, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Cuerpo</span>,
          tipo: ITipo_Campo.multiline,
          title: "Cuerpo",
          hide: true,
          required: true,
        } as any),
        columnHelperNotificacion.accessor((row) => row.ESTADO, {
          id: "ESTADO",
          cell: (info: CellContext<INotificacion, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Estado</span>,
          tipo: ITipo_Campo.none,
          title: "Estado",
        } as any),
        columnHelperNotificacion.accessor((row) => row.MODULO, {
          id: "MODULO",
          cell: (info: CellContext<INotificacion, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Módulo</span>,
          tipo: ITipo_Campo.none,
          title: "Módulo",
        } as any),
        columnHelperNotificacion.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "GravedadPotencial":
      const columnHelperGravedadPotencial = createColumnHelper<IGravedadPotencial>();

      return [
        columnHelperGravedadPotencial.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperGravedadPotencial.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperGravedadPotencial.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          hide: true,
          hideColOnEdit: true,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperGravedadPotencial.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "AmbitoDesviacion":
      const columnHelperAmbitoDesviacion = createColumnHelper<IAmbitoDesviacion>();

      return [
        columnHelperAmbitoDesviacion.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IAmbitoDesviacion, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperAmbitoDesviacion.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IAmbitoDesviacion, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Nombre</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperAmbitoDesviacion.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IAmbitoDesviacion, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperAmbitoDesviacion.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoDesviacion":
      const columnHelperTipoDesviacion = createColumnHelper<ITipoDesviacion>();

      return [
        columnHelperTipoDesviacion.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoDesviacion, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoDesviacion.accessor((row) => row.NOMBRE, {
          id: "NOMBRE",
          cell: (info: CellContext<ITipoDesviacion, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Nombre</span>,
          tipo: ITipo_Campo.text,
          title: "Nombre",
          required: true,
        } as any),
        columnHelperTipoDesviacion.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoDesviacion, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoDesviacion.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoCausaBasica":
      const columnHelperTipoCausaBasica = createColumnHelper<ITipoCausaBasica>();

      return [
        columnHelperTipoCausaBasica.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoDesviacion, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoCausaBasica.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ITipoDesviacion, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipoCausaBasica.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoDesviacion, boolean>) => (
            <i>{info.getValue() === true ? "Sí" : "No"}</i> //
          ),
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoCausaBasica.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "FactoresPersonales":
      const columnHelperFactoresPersonales = createColumnHelper<IFactoresPersonales>();

      return [
        columnHelperFactoresPersonales.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IFactoresPersonales, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.ID_FACTORES, {
          id: "ID_FACTORES",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID factores</span>,
          tipo: ITipo_Campo.text,
          title: "ID factores",
          required: true,
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.TIPO_FACTOR, {
          id: "ID_TIPO_FACTOR",
          cell: (info: CellContext<IFactoresPersonales, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo factor</span>,
          tipo: ITipo_Campo.combo,
          title: "Tipo factor",
          required: true,
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IFactoresPersonales, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.AUTOR, {
          id: "AUTOR",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID factores</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.EDITOR, {
          id: "EDITOR",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.AUTOR, {
          id: "AUTOR_DISPLAY",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>AUTOR</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHelperFactoresPersonales.accessor((row) => row.EDITOR, {
          id: "EDITOR_DISPLAY",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHelperFactoresPersonales.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "Capacidades":
      const columnHelperCapacidades = createColumnHelper<ICapacidades>();

      return [
        columnHelperCapacidades.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ICapacidades, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperCapacidades.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ICapacidades, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperCapacidades.accessor((row) => row.ID_CAPACIDADES, {
          id: "ID_CAPACIDADES",
          cell: (info: CellContext<ICapacidades, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID capacidad</span>,
          tipo: ITipo_Campo.text,
          title: "ID capacidades",
          required: true,
        } as any),
        columnHelperCapacidades.accessor((row) => row.TIPO_CAUSA, {
          id: "ID_FACTORES",
          cell: (info: CellContext<ICapacidades, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo causa</span>,
          tipo: ITipo_Campo.combo,
          title: "ID factor",
          required: true,
        } as any),
        columnHelperCapacidades.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ICapacidades, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperCapacidades.accessor((row) => row.AUTOR, {
          id: "AUTOR",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID factores</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHelperCapacidades.accessor((row) => row.EDITOR, {
          id: "EDITOR",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHelperCapacidades.accessor((row) => row.AUTOR, {
          id: "AUTOR_DISPLAY",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>AUTOR</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHelperCapacidades.accessor((row) => row.EDITOR, {
          id: "EDITOR_DISPLAY",
          cell: (info: CellContext<IFactoresPersonales, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHelperCapacidades.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoCausaInmediata":
      const columnHelperTipoCausaInmediata = createColumnHelper<ITipoCausaBasica>();

      return [
        columnHelperTipoCausaInmediata.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoCausaBasica, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoCausaInmediata.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ITipoCausaBasica, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipoCausaInmediata.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoCausaBasica, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoCausaInmediata.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "ActoCondicionSubestandar":
      const columnHelperIActoCondicionSubestandar = createColumnHelper<IActoCondicionSubestandar>();

      return [
        columnHelperIActoCondicionSubestandar.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IActoCondicionSubestandar, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IActoCondicionSubestandar, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.ID_ACTO, {
          id: "ID_ACTO",
          cell: (info: CellContext<IActoCondicionSubestandar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID acto</span>,
          tipo: ITipo_Campo.text,
          title: "ID acto",
          required: true,
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.TIPO_CAUSA, {
          id: "ID_TIPO_CAUSA",
          cell: (info: CellContext<IActoCondicionSubestandar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo causa</span>,
          tipo: ITipo_Campo.combo,
          title: "Tipo causa",
          required: true,
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IActoCondicionSubestandar, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.AUTOR, {
          id: "AUTOR",
          cell: (info: CellContext<IActoCondicionSubestandar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID factores</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.EDITOR, {
          id: "EDITOR",
          cell: (info: CellContext<IActoCondicionSubestandar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.AUTOR, {
          id: "AUTOR_DISPLAY",
          cell: (info: CellContext<IActoCondicionSubestandar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>AUTOR</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHelperIActoCondicionSubestandar.accessor((row) => row.EDITOR, {
          id: "EDITOR_DISPLAY",
          cell: (info: CellContext<IActoCondicionSubestandar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHelperIActoCondicionSubestandar.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "RequisitoSistema":
      const columnHelperRequisitoSistema = createColumnHelper<IRequisitoSistema>();
      return [
        columnHelperRequisitoSistema.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IRequisitoSistema, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperRequisitoSistema.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IRequisitoSistema, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperRequisitoSistema.accessor((row) => row.ID_REQUISITOS, {
          id: "ID_REQUISITOS",
          cell: (info: CellContext<IRequisitoSistema, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID ámbito</span>,
          tipo: ITipo_Campo.text,
          title: "ID ámbito",
          required: true,
        } as any),
        columnHelperRequisitoSistema.accessor((row) => row.TIPO_REQUISITOS, {
          id: "ID_TIPO_REQUISITOS",
          cell: (info: CellContext<IRequisitoSistema, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo ámbito</span>,
          tipo: ITipo_Campo.combo,
          title: "Tipo ámbito",
          required: true,
        } as any),
        columnHelperRequisitoSistema.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IRequisitoSistema, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),

        columnHelperRequisitoSistema.accessor((row) => row.AUTOR_DISPLAY, {
          id: "AUTOR",
          cell: (info: CellContext<IRequisitoSistema, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID factores</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHelperRequisitoSistema.accessor((row) => row.EDITOR_DISPLAY, {
          id: "EDITOR",
          cell: (info: CellContext<IRequisitoSistema, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHelperRequisitoSistema.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;

    case "AgentesCausantes":
      const columnHelpeAgentesCausantes = createColumnHelper<IAgentesCausantes>();
      return [
        columnHelpeAgentesCausantes.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelpeAgentesCausantes.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelpeAgentesCausantes.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelpeAgentesCausantes.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "Efectos":
      const columnHelperEfectos = createColumnHelper<IEfectos>();

      return [
        columnHelperEfectos.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperEfectos.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperEfectos.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperEfectos.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "NaturalezaLesiones":
      const columnHelperNaturalezaLesiones = createColumnHelper<INaturalezaLesiones>();

      return [
        columnHelperNaturalezaLesiones.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperNaturalezaLesiones.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperNaturalezaLesiones.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperNaturalezaLesiones.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "ParteCuerpoLesionado":
      const columnHelperParteCuerpoLesionado = createColumnHelper<IParteCuerpoLesionado>();

      return [
        columnHelperParteCuerpoLesionado.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperParteCuerpoLesionado.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperParteCuerpoLesionado.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperParteCuerpoLesionado.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoContacto":
      const columnHelperTipoContacto = createColumnHelper<ITipoContacto>();

      return [
        columnHelperTipoContacto.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoContacto.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipoContacto.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoContacto.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;

    case "Clasificacion":
      const columnHelperClasificacion = createColumnHelper<ITipoContacto>();

      return [
        columnHelperClasificacion.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperClasificacion.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperClasificacion.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperClasificacion.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipificacionIncidente":
      const columnHelperTipificacionIncidente = createColumnHelper<ITipoContacto>();

      return [
        columnHelperTipificacionIncidente.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipificacionIncidente.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipificacionIncidente.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipificacionIncidente.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "AreaResponsable":
      const columnHelperAreaResponsable = createColumnHelper<IAreaResponsable>();

      return [
        columnHelperAreaResponsable.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IAreaResponsable, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperAreaResponsable.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IAreaResponsable, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Área Responsable</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperAreaResponsable.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IAreaResponsable, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperAreaResponsable.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "Parametros":
      const columnHelperParametros = createColumnHelper<ITipoContacto>();

      return [
        columnHelperParametros.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IGravedadPotencial, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperParametros.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IGravedadPotencial, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Parámetro</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperParametros.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IGravedadPotencial, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperParametros.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoProceso":
      const columnHelperTipoProceso = createColumnHelper<ITipoProceso>();

      return [
        columnHelperTipoProceso.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoProceso, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoProceso.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ITipoProceso, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo de Proceso</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipoProceso.accessor((row) => row.AREA_RESPONSABLE, {
          id: "ID_AREA_RESPONSABLE",
          cell: (info: CellContext<ITipoProceso, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Area Responsable</span>,
          tipo: ITipo_Campo.combo,
          title: "Area Responsable",
          required: true,
        } as any),
        columnHelperTipoProceso.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoProceso, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoProceso.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoAuditoria":
      const columnHelperTipoAuditoria = createColumnHelper<ITipoAuditoria>();

      return [
        columnHelperTipoAuditoria.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoAuditoria, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoAuditoria.accessor((row) => row.NOMBRE, {
          id: "NOMBRE",
          cell: (info: CellContext<ITipoAuditoria, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Nombre</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipoAuditoria.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoAuditoria, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoAuditoria.accessor((row) => row.ES_GLOBAL, {
          id: "ES_GLOBAL",
          cell: (info: CellContext<ITipoAuditoria, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Es Particular</span>,
          tipo: ITipo_Campo.check,
          title: "Es Particular",
        } as any),
        columnHelperTipoAuditoria.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoUnidadAuditar":
      const columnHelperTipoUnidadAuditar = createColumnHelper<ITipoUnidadAuditar>();

      return [
        columnHelperTipoUnidadAuditar.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoUnidadAuditar, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoUnidadAuditar.accessor((row) => row.NOMBRE, {
          id: "NOMBRE",
          cell: (info: CellContext<ITipoUnidadAuditar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Nombre</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipoUnidadAuditar.accessor((row) => row.TIPO_AUDITORIA, {
          id: "ID_TIPO_AUDITORIA",
          cell: (info: CellContext<ITipoUnidadAuditar, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo Auditoría</span>,
          tipo: ITipo_Campo.combo,
          title: "Tipo Auditoría",
        } as any),
        columnHelperTipoUnidadAuditar.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoUnidadAuditar, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoUnidadAuditar.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoAlcance":
      const columnHelperTipoAlcance = createColumnHelper<ITipoAlcance>();

      return [
        columnHelperTipoAlcance.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoAlcance, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHelperTipoAlcance.accessor((row) => row.NOMBRE, {
          id: "NOMBRE",
          cell: (info: CellContext<ITipoAlcance, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Nombre</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHelperTipoAlcance.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoAlcance, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHelperTipoAlcance.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        }),
      ] as any;
    case "TipoIncidentes":
      const columnHpTIpoIncidentes = createColumnHelper<ITipoIncidentes>();
      const colsTi = [
        columnHpTIpoIncidentes.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoIncidentes, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHpTIpoIncidentes.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ITipoIncidentes, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnHpTIpoIncidentes.accessor((row) => row.USUARIO_RESPONSABLE_DISPLAY, {
          id: "USUARIO_RESPONSABLE",
          cell: (info: CellContext<ITipoIncidentes, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Usuario responsable",
          required: true,
        } as any),
        columnHpTIpoIncidentes.accessor((row) => row.USUARIO_BACKUP_DISPLAY, {
          id: "USUARIO_BACKUP",
          cell: (info: CellContext<ITipoIncidentes, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario backup</span>,
          tipo: ITipo_Campo.user,
          title: "Backup responsable",
        } as any),
        columnHpTIpoIncidentes.accessor((row) => row.ES_USUARIO_BACKUP, {
          id: "ES_USUARIO_BACKUP",
          cell: (info: CellContext<ITipoIncidentes, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>¿Es Usuario Backup?</span>,
          tipo: ITipo_Campo.check,
          title: "¿Es responsable Backup?",
        } as any),
        columnHpTIpoIncidentes.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoIncidentes, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnHpTIpoIncidentes.accessor((row) => row.AUTOR, {
          id: "AUTOR",
          cell: (info: CellContext<ITipoIncidentes, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID factores</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHpTIpoIncidentes.accessor((row) => row.EDITOR, {
          id: "EDITOR",
          cell: (info: CellContext<ITipoIncidentes, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHpTIpoIncidentes.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<ITipoIncidentes, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return colsTi as any;
    case "TipoIncidenteUsuario":
      const columnHpTIpoIncidenteUsuario = createColumnHelper<ITipoIncidenteUsuario>();
      const colsTiu = [
        columnHpTIpoIncidenteUsuario.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoIncidenteUsuario, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ITipoIncidenteUsuario, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          sorteditmode: 1,
          required: true,
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.NOMBRE_TIPO_INCIDENTE, {
          id: "ID_TIPO_INCIDENTE",
          cell: (info: CellContext<ITipoIncidenteUsuario, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo Incidente</span>,
          tipo: ITipo_Campo.combo,
          title: "Tipo Incidente",
          sorteditmode: 4,
          required: true,
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.USUARIO_RESPONSABLE_DISPLAY, {
          id: "USUARIO_RESPONSABLE",
          cell: (info: CellContext<ITipoIncidenteUsuario, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario responsable</span>,
          tipo: ITipo_Campo.user,
          title: "Usuario responsable",
          sorteditmode: 2,
          required: true,
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.USUARIO_BACKUP_DISPLAY, {
          id: "USUARIO_BACKUP",
          cell: (info: CellContext<ITipoIncidenteUsuario, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario backup</span>,
          tipo: ITipo_Campo.user,
          title: "Backup responsable",
          sorteditmode: 3,
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.ES_USUARIO_BACKUP, {
          id: "ES_USUARIO_BACKUP",
          cell: (info: CellContext<ITipoIncidenteUsuario, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>¿Es Usuario Backup?</span>,
          tipo: ITipo_Campo.check,
          title: "¿Es responsable backup?",
          sorteditmode: 5,
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoIncidenteUsuario, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
          sorteditmode: 6,
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.AUTOR, {
          id: "AUTOR",
          cell: (info: CellContext<ITipoIncidenteUsuario, number>) => <i>{info.getValue()}</i>,
          header: () => <span>ID factores</span>,
          tipo: ITipo_Campo.key,
          title: "AUTOR",
          hide: true,
        } as any),
        columnHpTIpoIncidenteUsuario.accessor((row) => row.EDITOR, {
          id: "EDITOR",
          cell: (info: CellContext<ITipoIncidenteUsuario, number>) => <i>{info.getValue()}</i>,
          header: () => <span>EDITOR</span>,
          tipo: ITipo_Campo.key,
          title: "EDITOR",
          hide: true,
        } as any),
        columnHpTIpoIncidenteUsuario.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<ITipoIncidenteUsuario, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return colsTiu as any;

    case "Aspecto":
      const columnLIOAspecto = createColumnHelper<IAspecto>();
      const colsAspecto = [
        columnLIOAspecto.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IAspecto, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnLIOAspecto.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IAspecto, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnLIOAspecto.accessor((row) => row.ID_NODO_ASPECTO, {
          id: "ID_NODO_ASPECTO",
          cell: (info: CellContext<IAspecto, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Nodo Aspecto</span>,
          tipo: ITipo_Campo.text,
          title: "Nodo Aspecto",
          required: true,
        } as any),
        columnLIOAspecto.accessor((row) => row.NOMBRE_ELEMENTO, {
          id: "NOMBRE_ELEMENTO",
          cell: (info: CellContext<IAspecto, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Nombre Elemento</span>,
          tipo: ITipo_Campo.text,
          title: "Nombre Elemento",
          required: true,
        } as any),
        columnLIOAspecto.accessor((row) => row.NOMBRE_TIPO_ASPECTO, {
          id: "ID_TIPO_ASPECTO",
          cell: (info: CellContext<IAspecto, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo de Faena</span>,
          tipo: ITipo_Campo.combo,
          title: "Tipo de Faena",
        } as any),
        columnLIOAspecto.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IAspecto, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnLIOAspecto.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<IAspecto, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return colsAspecto as any;

    case "Faena":
      const columnLIOFaena = createColumnHelper<IFaena>();
      const colsFaena = [
        columnLIOFaena.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<IFaena, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnLIOFaena.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IFaena, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnLIOFaena.accessor((row) => row.NOMBRE_TIPO_FAENA, {
          id: "ID_TIPO_FAENA",
          cell: (info: CellContext<IFaena, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Tipo de Faena</span>,
          tipo: ITipo_Campo.combo,
          title: "Tipo de Faena",
          required: true,
        } as any),
        columnLIOFaena.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IFaena, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnLIOFaena.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<IFaena, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return colsFaena as any;

    case "TipoFaena":
      const columnLIOTipoFaena = createColumnHelper<ITipoFaena>();
      const colsTipoFaena = [
        columnLIOTipoFaena.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoFaena, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnLIOTipoFaena.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ITipoFaena, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnLIOTipoFaena.accessor((row) => row.NUEVO_FORMATO, {
          id: "NUEVO_FORMATO",
          cell: (info: CellContext<ITipoFaena, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Nuevo formato</span>,
          tipo: ITipo_Campo.check,
          title: "Nuevo formato",
        } as any),
        columnLIOTipoFaena.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ITipoFaena, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnLIOTipoFaena.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<ITipoFaena, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return colsTipoFaena as any;
    case "TipoEvaluacion":
      const columnLIOTipoEvaluacion = createColumnHelper<ITipoEvaluacion>();
      const colsTipoEvaluacion = [
        columnLIOTipoEvaluacion.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ITipoEvaluacion, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnLIOTipoEvaluacion.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ITipoEvaluacion, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnLIOTipoEvaluacion.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<ITipoEvaluacion, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return colsTipoEvaluacion as any;
    case "LIOInspectorTranselec":
      const columnLIOInspectorTranselec = createColumnHelper<ILIOInspectorTranselec>();
      const colsLIOInspectorTranselec = [
        columnLIOInspectorTranselec.accessor("ID", {
          id: "ID",
          cell: (info: CellContext<ILIOInspectorTranselec, number>) => info.getValue(),
          header: () => <span>ID</span>,
          tipo: ITipo_Campo.key,
          title: "ID",
        } as any),
        columnLIOInspectorTranselec.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<ILIOInspectorTranselec, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          tipo: ITipo_Campo.text,
          title: "Título",
          required: true,
        } as any),
        columnLIOInspectorTranselec.accessor((row) => row.NOMBRE_GERENCIA, {
          id: "ID_GERENCIA_SUBGERENCIA",
          cell: (info: CellContext<ILIOInspectorTranselec, number>) => <i>{info.getValue()}</i>,
          header: () => <span>Gerencia</span>,
          tipo: ITipo_Campo.combo,
          title: "Gerencia",
          hide: true,
          required: true,
        } as any),
        columnLIOInspectorTranselec.accessor((row) => row.NOMBRE_GERENCIA, {
          id: "NOMBRE_GERENCIA",
          cell: (info: CellContext<ILIOInspectorTranselec, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Gerencia</span>,
          tipo: ITipo_Campo.none,
          title: "Gerencia",
        } as any),
        columnLIOInspectorTranselec.accessor((row) => row.USUARIO_DISPLAY, {
          id: "USUARIO",
          cell: (info: CellContext<ILIOInspectorTranselec, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Usuario</span>,
          tipo: ITipo_Campo.user,
          title: "Usuario",
          required: true,
        } as any),
        columnLIOInspectorTranselec.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<ILIOInspectorTranselec, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          tipo: ITipo_Campo.check,
          title: "Activo",
        } as any),
        columnLIOInspectorTranselec.display({
          id: "editar",
          header: () => <span>Editar</span>,
          tipo: ITipo_Campo.button,
          texto: "Editar",
          cell: (props: CellContext<ILIOInspectorTranselec, number>) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
        } as any),
      ];
      return colsLIOInspectorTranselec as any;

    case "Roles":
      const columnHelperRoles = createColumnHelper<IRoles>();

      return [
        columnHelperRoles.accessor("ID", {
          cell: (info) => info.getValue(),
          footer: (info) => info.column.id,
        }),
        columnHelperRoles.accessor((row) => row.TITULO, {
          id: "TITULO",
          cell: (info: CellContext<IRoles, string>) => <i>{info.getValue()}</i>,
          header: () => <span>Título</span>,
          hide: false,
          title: "Titulo",
          tipo: ITipo_Campo.text,
        } as any),
        columnHelperRoles.accessor((row) => row.ACTIVO, {
          id: "ACTIVO",
          cell: (info: CellContext<IRoles, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
          header: () => <span>Activo</span>,
          title: "Activo",
          tipo: ITipo_Campo.check,
        } as any),
        columnHelperRoles.display({
          id: "editar",
          header: () => <span>Editar</span>,
          cell: (props: any) => (
            <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
              <i className="bi bi-search"></i>
            </a>
          ),
          title: "Editar",
        } as any),
      ] as any;

    default:
      return [];
  }
}
